import { Button } from 'components/Button';
import { VoucherForm } from 'components/Forms/VoucherForm';
import { DashboardTitle } from 'components/Titles';
import { format } from 'date-fns';
import { FC, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { voucherValidation } from 'schemas';
import { VoucherService } from 'services/voucher.service';
import { IVoucherCreate } from 'types/Voucher';

import { Box, CircularProgress, Grid } from '@mui/material';

const defaultValues: IVoucherCreate = {
  description: '',
  name: '',
  type: 'percentage',
  value: 0,
  expireAt: null,
  quantity: 0,
  forever: false,
  dateLimited: false,
  limited: false,
};

export const VoucherCreate: FC = () => {
  const history = useHistory();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');
  const [success, setSuccess] = useState<string>('');

  const form = useForm<IVoucherCreate>({
    defaultValues,
    resolver: voucherValidation(),
  });

  const handleSubmit = (values: any) => {
    setLoading(true);

    VoucherService.createVoucher({
      ...values,
      expireAt: values.expireAt
        ? format(new Date(values.expireAt), 'yyyy-MM-dd')
        : null,
      name: values.name.toUpperCase().trim(),
    })
      .then(
        () => {
          setError('');
          setSuccess('Cupom cadastrado com sucesso');
          form.reset();
        },
        ({ response }) => {
          setSuccess('');
          setError(response?.data?.error || 'Erro no cadastro do cupom');
        }
      )
      .finally(() => {
        setLoading(false);
        setTimeout(() => {
          setError('');
          setSuccess('');
        }, 6000);
      });
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <DashboardTitle title="GESTÃO DE CUPONS" />
      </Grid>
      <Grid item xs={12}>
        <FormProvider {...form}>
          <VoucherForm error={error} success={success} loading={loading} />
          <Box py={1}>
            <Grid container spacing={1} justifyContent="flex-end">
              <Grid item>
                <Button onClick={history.goBack}>voltar</Button>
              </Grid>
              <Grid item>
                <Button
                  onClick={form.handleSubmit(handleSubmit)}
                  disabled={loading}
                >
                  CADASTRAR
                  {loading && (
                    <CircularProgress
                      size="small"
                      sx={{ width: 24, height: 24, ml: 2 }}
                    />
                  )}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </FormProvider>
      </Grid>
    </Grid>
  );
};

